import {actionTypes, flightTypes, resourceTypes, workplaceTypes } from "../types";
import { isEnabledMsg, isUnreadMsg } from "@/utils.js";
import { HeaderMenuBlock } from '../Block/HeaderMenuBlock/HeaderMenuBlock'
import { TIME_FORMAT } from '@/utils.js'
import { appNotification } from '@/components/AppNotification.js'
import { storage } from "@/components/Storage";
import { user } from "@/components/User";
import { cache } from '@/components/Cache.js';
import { interval } from '@/components/Interval.js';
import { loader } from '@/components/Loader.js';
import { server } from '@/components/Server.js';

var AgentTask = {
    time: null,
    list: [],
    error: '',
    init: function (ping) {
        return m.request({
            method: 'GET',
            url: '/api/tasks'
        }).then(function (response) {
            server.setOnline();

            AgentTask.time = response.time;
            AgentTask.list = response.tasks;

            loader.hide();
            storage.config = response.config;

            if (ping) {
                server.initPing();
            }
            
            appNotification.init();

            return response;
        }, function (response) {
            if (response && response.message) {
                AgentTask.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        })
    },
    confirm: function (key) {
        AgentTask.error = '';
        loader.show();

        var task = AgentTask.list[key];

        m.request({
            method: 'PUT',
            url: '/api/task/' + task.id + '/confirm'
        }).then(function () {
            loader.hide();

            task.isConfirmed = true;
            task.url = '/task/' + task.id + '/operation';

        }, function (response) {

            cache.push({
                type: actionTypes.taskConfirm,
                taskId: task.id,
                ts: moment().format(TIME_FORMAT)
            });

            if (response && response.message) {
                AgentTask.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    },
    initIntervalRefresh: function () {
        interval.make(function () {
            AgentTask.init(false)
        }, 30000)
    }
};

export var AgentTasksPage = {
    controller: function () {

        if (!user.exists()) {
            m.route('/login');
            return;
        }
        if (!user.has('state.workplace')) {
            m.route('/workplace');
            return;
        }
        if (user.get('state.workplace') === workplaceTypes.driver) {
            m.route('/vehicle/tasks');
            return;
        }
        if (user.get('state.workplace') === workplaceTypes.supervisor || user.get('state.workplace') === workplaceTypes.executor) {
            m.route('/');
            return;
        }
        if (user.get('state.workplace') === workplaceTypes.security) {
            m.route('/security/flights');
            return;
        }

        interval.clearAll();

        loader.show();

        var data = AgentTask.init(true);

        setTimeout(function () {
            AgentTask.initIntervalRefresh()
        }, 500);

        return {
            data: data,
            topMenu: [
                { title: 'Задачи', url: '/', icon: 'fa-tasks' },
                { title: 'Рейсы', url: '/agent/flights', icon: 'fa-plane' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ]
        }
    },
    view: function (ctrl) {
        return [
            m.component(HeaderMenuBlock, {
                time: AgentTask.time,
                menu: ctrl.topMenu
            }),
            m("div[style='margin-top:0px']", AgentTask.error),
            m("table.table.table-bordered.table-condensed", [
                m("thead", [
                    m("tr", [
                        m("th.text-center", "Рейс"),
                        m("th.text-center", "Вылет"),
                        m("th.text-center", "Ресурсы"),
                        m("th", "")
                    ])
                ]),
                m("tbody", [
                    AgentTask.list.map(function (task, i) {
                        return m("tr", {class: task.isOverdue ? 'bg-grey' : ''}, [
                            m("td.v-center", [
                                m("a.btn.btn-block.btn-lg", {
                                        href: task.url,
                                        class: task.hasAlerts ? 'btn-warning progress-bar-striped' : 'btn-default',
                                        config: m.route
                                    },
                                    task.isCrossWork ?
                                        m("span.label.label-danger[style='margin-right:3px']", m("i.fa.fa-exclamation")) : '',
                                    m("span.label", {
                                        class: task.operationType === resourceTypes.registration ? 'label-info' : 'label-success'
                                    }, task.operation),
                                    m("span[style='display:inline-block;padding-left:7px;']", [
                                        m('span', task.flightNumber),
                                        task.flightType > -1 ? m("br") : '',
                                        task.flightType === flightTypes.departure ?
                                            [m('img', {src: "/img/departure.png"}), m.trust('&nbsp;' + task.airportCode)] : '',
                                        task.flightType === flightTypes.arrival ?
                                            [m('img', {src: "/img/arrival.png"}), m.trust(task.airportCode + '&nbsp;')] : '',
                                        task.flightType === flightTypes.around ?
                                            [m('img', {src: "/img/around.png"}), m.trust('&nbsp;' + task.airportCode)] : '',
                                        m("br"),
                                        m('span', task.boardNumber),
                                        m("br"),
                                        m('span' + task.airportCode)
                                    ])
                                )
                            ]),
                            m("td.text-center.v-center", [
                                m("span.big-text", task.flightTime),
                                m("br"),
                                m("span", task.flightDate)
                            ]),
                            m("td.text-center.v-center", [
                                m("div[style='max-height:100px;overflow-y:auto;']", [
                                    task.resources.map(function(resource) {
                                        return m("div", [
                                            m("span", resource.name),
                                            m("br")
                                        ])
                                    })
                                ]),
                            ]),
                            m("td.col-xs-2.text-center.v-center", [
                                task.isConfirmed ?
                                    m("i.fa.fa-3x.fa-check.text-primary") :
                                    m("button.btn.btn-info.btn-lg", {onclick: function () {
                                            AgentTask.confirm(i);
                                        }}, [
                                        m("i.fa.fa-2x.fa-thumbs-o-up")
                                    ])
                            ])
                        ])
                    })
                ])
            ])
        ];
    }
};
